module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C126"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "auto",
      "src": "Images/image00220.jpeg",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "C141"
  }, [_c('span', {
    staticClass: "Underline"
  }, [_c('strong', [_vm._v("Special Acknowledgment")])])]), _vm._v(" "), _c('p', {
    staticClass: "C137"
  }, [_vm._v("A final word is especially fitting for the new editions of "), _c('em', [_vm._v("Malcolm")]), _vm._v(" and "), _c('em', [_vm._v("The Marquis of Lossie")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "C137"
  }, [_vm._v("Cullen’s memorial George MacDonald bench owes a heartfelt word of gratitude to three men. The entire Castle Hill project—reclaiming the inaccessible and nearly forgotten historic site from both gorse and forgetfulness—has been their visionary brainchild, and owes thousands of hours of "), _c('em', [_vm._v("very")]), _vm._v(" hard work (literally through rain, wind, sleet, and snow) to Dennis Paterson, Barry Addison, and Stan Slater.")]), _vm._v(" "), _c('p', {
    staticClass: "C137"
  }, [_vm._v("All Cullen, and all lovers of George MacDonald, owe them (and their many co-labourers) profound appreciation. They have contributed, as have many through the years, in yet one more way of keeping the history of Cullen, and the legacy of George MacDonald, vibrant and alive for future generations.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e24020a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0008.vue
// module id = 81
// module chunks = 0